/**
 * @name isDefined
 * @description This function tests that the value is not null or undefined (A empty string is consider as defined)
 * @param {any} value The value to test
 * @returns {boolean} Is the value defined
 *
 * @example
 * // With value
 * import {isDefined} from 'gso-utilities';
 * const item = {name: 'Thor'};
 * const defined = isDefined(item.name);
 * console.log(defined); //true
 *
 * @example
 * // With undefined
 * import {isDefined} from 'gso-utilities';
 * const item = {name: 'Thor'};
 * const defined = isDefined(item.surname);
 * console.log(defined); // false
 *
 * @example
 * // With undefined
 * import {isDefined} from 'gso-utilities';
 * const item = {name: ''};
 * const defined = isDefined(item.name);
 * console.log(defined); // true
 *
 * @example
 * // With null
 * import {isDefined} from 'gso-utilities';
 * const item = {name: 'Thor', wings: null};
 * const defined = isDefined(item.wings);
 * console.log(defined); // false
 *
 */
function isDefined(value) {
    return value !== undefined && value !== null;
}
export { isDefined };
//# sourceMappingURL=is-defined.js.map